import {React} from 'external/react'
import {styled} from 'external/material'
import ExpectationItem from './ExpectationItem'

const Results = styled('div')(({theme}) => ({display:'flex', flexDirection:'column', gap:theme.spacing(1.5), minHeight:0, overflow:'visible', padding:theme.spacing(0.5, 0.25), '& > section':{flexShrink:0}}))
const Message = styled('div')(({theme}) => ({padding:theme.spacing(3), textAlign:'center', color:theme.palette.text.secondary, border:'1px solid ' + theme.palette.divider, borderRadius:theme.shape.borderRadius}))

export default function ExpectationsList ({expectations = [], selected, mode, edition, onToggle, dataset = {}, onRetry}) {
  return <Results>
    {dataset.status === 'loading' && <Message role="status">Cargando expectativas…</Message>}
    {dataset.status === 'empty' && <Message>No se encontraron expectativas</Message>}
    {dataset.status === 'error' && <Message role="alert">No se pudieron cargar las expectativas. <button type="button" onClick={onRetry}>Reintentar</button></Message>}
    {dataset.status === 'ready' && expectations.map(expectation =>
      <ExpectationItem key={expectation.id} expectation={expectation} selected={selected} mode={mode} edition={edition} onToggle={onToggle}/>)}
  </Results>
}
